<template>
  <div class="tags-manage-index admin-table-page">
    <div class="table-tools">
      <div class="tt-search">
        <div class="tt-center">
          <label class="tt-title ff-title">项目组</label>
          <span class="c-search-box tt-ipt">
            <el-input v-model="projectName" placeholder="搜索项目组"></el-input>
            <el-button
              type="primary"
              circle
              class="c-search-btn"
            >
              <i class="iconfont icon-search"></i>
            </el-button>
        </span>
        </div>
      </div>
      <div class="tt-projects transition" :style="renderParentStyle">
        <ul >
          <!-- <li class="ttp-item" :class="{'active': params.projectId === null}" @click="queryByProject(null)">全部项目组</li> -->
          <li
            v-for="(item) in adminProjectsList"
            :key="item.id"
            :class="{'active': params.projectId === item.id}"
            class="ttp-item"
            v-text="item.name"
            @click="queryByProject(item.id)"
          ></li>
        </ul>
        <div class="ttp-cover transition"  :style="renderExpandStyle">
          <i @click="onExpand" class="transition arrow-down el-icon-arrow-down" :class="isExpanded ? 'c-reverse': ''"></i>
        </div>
      </div>
      <div class="tt-type">
        <div>
          <label class="ttt-label">
            作品标签编辑
          </label>
        </div>
      </div>
    </div>
    <div
      v-if="true"
      class="p-loading"
      v-loading="pageLoading"
      element-loading-text="拼命加载中, 请稍候"
      element-loading-spinner="el-icon-loading"
    />
    <section class="table-body">
      <div style="text-align: left;">
        <el-button
          v-if="params.projectId"
          size="small"
          icon="el-icon-plus"
          class="tag-item"
          plain
          @click="onAddTag"
        >添加标签</el-button>
        <template v-for="item in tagsList">
          <el-tag
            :key="item.id"
            type="info"
            size="large"
            class="tag-item"
            closable
            effect="plain"
            @close="onDel(item)"
          >
            {{ item.name }}
          </el-tag>
        </template>
      </div>
      <el-dialog
        title="新建标签"
        :visible.sync="dialogVisible"
        custom-class="add-tag-dialog"
        width="30%">
        <el-form ref="addTagForm" :rules="rules" :model="tagNameForm" label-width="60px" label-position="left">
          <el-form-item label="名称：" prop="name">
            <el-input v-model="tagNameForm.name" maxlength="12" placeholder="请输入标签名称" show-word-limit></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button :loading="comfirmLoading" type="primary" @click="handleTagAddConfirm">确 定</el-button>
        </span>
      </el-dialog>
    </section>
  </div>
</template>
<script>
    import tagsService from '../../../request/service/tags-service'
    import projectService from '../../../request/service/project-service'
    export default {
        data() {
            return {
                tagNameForm: {
                  name: ''
                },
                rules: {
                  name: [
                    { required: true, message: '请输入标签名称', trigger: 'blur' },
                  ]
                },
                comfirmLoading: false,
                dialogVisible: false,
                pageLoading: false,
                tagsList: [],
                projectName: '',
                params:{
                    projectId: null,
                },
                isExpanded: false,
                adminProjects: []
            }
        },
        computed: {
            adminProjectsList(){
                let searchStr = this.projectName.toLowerCase();
                return this.adminProjects.filter((item) => {
                    return item.name.toLowerCase().indexOf(this.projectName) > -1
                });
            },
            renderParentStyle(){
                if(!this.isExpanded){
                    return 'height: 65px'
                }
                return null;
            },
            renderExpandStyle(){
                return this.isExpanded ? 'height: 25px' : 'height: 42px;line-height: 42px;';
            },
            fontList() {
                let queryStr = this.params.name;
                if (!queryStr) return this.originFontList;
                return  this.originFontList.filter((item) => {
                    return item.name.indexOf(queryStr) > -1 || item.alias.indexOf(queryStr) > -1
                });
            },
            checkedIds() {
                let ids = [];
                this.fontList.map((item) => {
                    if (item.checked) {
                        ids.push(item.id);
                    }
                });
                return ids;
            },
        },
        watch: {
          adminProjects (val) {
            this.params.projectId = val.length > 0 ? val[0].id : null
            if (this.params.projectId) {
              this.getData()
            } else {
              this.tagsList = []
            }
          }
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                this.getProjectList();
            },
            getData() {
                this.pageLoading = true;

                const params = {
                  type: 'WORK'
                }
                const header = {
                  projectId: this.params.projectId
                }
                tagsService.getTagsList(params, header).then(dataList => {
                  this.tagsList = dataList
                }).finally(() => {
                  this.pageLoading = false
                })
            },
            getProjectList(){
                projectService.getAdminProjects().then((data) => {
                    this.adminProjects = data;
                });
            },
            handleTagAddConfirm () {
              this.$refs['addTagForm'].validate((valid) => {
                if (valid) {
                  this.comfirmLoading = true
                  tagsService.addTag({
                    projectId: this.params.projectId,
                    name: this.tagNameForm.name,
                    type: 'WORK'
                  }).then(data => {
                    this.$message.success('添加标签成功')
                    this.dialogVisible = false
                    this.getData()
                  }).catch((e) => {
                    this.$message.error(e.message)
                  }).finally(() => {
                    this.comfirmLoading = false
                  })
                } else {
                  return false
                }
              });
            },
            onAddTag() {
              this.tagNameForm.name = ''
              this.dialogVisible = true
            },
            onDel(item) {
                this.$confirm(`<div>
                  <div style="text-align: center; color: #333; font-size: 16px;">确定删除“${item.name}”标签吗？</div>
                  <div style="text-align: center; color: #999; font-size: 14px;">（删除标签不会影响对应的作品）</div>
                </div>`, '提示', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    beforeClose: (action, instance, done) => {
                      if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        tagsService.delTag({
                          id: item.id
                        }).then(data => {
                          this.$message.success('标签删除成功')
                          this.getData()
                          done();
                        }).catch(() => {
                          this.$message.error('标签删除失败')
                        }).finally(() => {
                          instance.confirmButtonLoading = false
                        })
                      } else {
                        done()
                      }
                    }
                }).then(() => {}).catch(() => {});
            },
            queryByProject(pid){
                if(this.pageLoading){
                    return;
                }
                this.params.projectId = pid;
                this.getData();
            },
            onExpand(){
                this.isExpanded = !this.isExpanded;
            }
        }
    }
</script>
<style lang="scss">
  @import "./tags.scss";
</style>